"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
* Interface for Dispatcher implementations
* @interface DispatcherInterface
*/
/**
* Dispatch an event
*
* @function
* @name DispatcherInterface#dispatch
*
* @param {string} evt
*/
/**
* subscribe to an event
*
* @function
* @name DispatcherInterface#on
*
* @param {string} evt
* @param {function} cb
*/
/**
* Unsubscribe from an event
* if no cb provided, all listeners to the event are unsubscribed
*
* @function
* @name DispatcherInterface#off
*
* @param {string} evt
* @param {function} [cb]
*/

/**
* @namespace Dispatcher
* @implements {DispatcherInterface}
*/
var Dispatcher = {
    /**
    * Dispatch an event
    * @param {string} evt
    */
    dispatch: function dispatch() {
        if (window.PathDispatcher) {
            return window.PathDispatcher.dispatch.apply(window.PathDispatcher, arguments);
        }
    },
    /**
    * subscribe to an event
    *
    * @param {string} evt
    * @param {function} cb
    */
    on: function on() {
        if (window.PathDispatcher) {
            return window.PathDispatcher.on.apply(window.PathDispatcher, arguments);
        }
    },
    /**
    * Unsubscribe from an event
    * if no cb provided, all listeners to the event are unsubscribed
    *
    * @param {string} evt
    * @param {function} [cb]
    */
    off: function off() {
        if (window.PathDispatcher) {
            return window.PathDispatcher.off.apply(window.PathDispatcher, arguments);
        }
    }
};
exports.default = Dispatcher;